import createSpinner from "../../../../Shared/Functions/createSpinner";

export default /*@ngInject*/ function ($filter, $uibModalInstance, reviewItem, notesRequired, enableReasons, allowCancel, helperService, reasonsDataService) {
    const vm = this;
    
    vm.reviewItem = reviewItem ? { ...reviewItem } : null;
    vm.notesRequired = notesRequired;
    vm.allowCancel = allowCancel;

    vm.saveNotes = saveNotes;
    vm.enableReasons = enableReasons;
    vm.dismiss = dismiss;

    activate();
    async function activate() {
        if (vm.enableReasons) {
            vm.loading = true;
            await loadReasons();
            vm.loading = false;
        }
    }

    async function loadReasons() {
        vm.reasonsDropdownLoading = true;
        let response = await reasonsDataService.listReasons();
        vm.reasons = response.data;

        let selectAReasonOption = {
            Name: '-- Select a Reason --',
            Id: null
        };

        vm.reasonCount = vm.reasons.length;
        response.data.push(selectAReasonOption);
        response.data = $filter('orderBy')(response.data, 'Name');
        vm.reasonsDataSource = response.data;
        vm.reasonsDropdownLoading = false;
    }

    function dismiss() {
        $uibModalInstance.dismiss();
    }

    async function saveNotes(item) {
        vm.savingNotes = new createSpinner();

        var responseObject = new Object();

        responseObject.Notes = vm.reviewItem.Notes;
        responseObject.ReasonId = vm.reviewItem.ReasonId;

        if (vm.reviewItem.ReasonId) {
            let selectedReason = vm.reasons.find(reason => reason.Id === vm.reviewItem.ReasonId);
            responseObject.ReasonName = selectedReason.Name;
        }


        await helperService.successfulSaveButton(vm.savingNotes);

        $uibModalInstance.close(responseObject);
    }

}